import { LoadableAfterPaint } from '@confluence/loadable';

const ConnectSupport = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ConnectSupport" */ './ConnectSupport'))
			.ConnectSupport,
});

export { ConnectSupport };
